// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './lib-flexible';
import Vue from 'vue'
import MintUI from 'mint-ui';
import { dataHandle } from './services/data-handle.js'
import App from './App'
import router from './router'
import { http } from './services/http';
import 'mint-ui/lib/style.css';

import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);
import preview from 'vue-photo-preview';
import 'vue-photo-preview/dist/skin.css';
Vue.use(preview);
Vue.use(MintUI);

// import vConsole from './vconsole.js'

sessionStorage.setItem('accessKey','068515cb-00f0-47ed-bc3a-717096f308ec')

window.api = process.env['API'];
window.socket = process.env['SOCKET_API'];
window.fileApi = process.env['FILE_API'];
window.artificialLink = process.env['XCHAT'];

Vue.prototype.$http = http;

Vue.config.productionTip = false;

function getPathData(val){
  const locationUrk = window.location.href + '';
  const locationLits = locationUrk.split('?') || [];
  const query = locationLits[locationLits.length -1] || '';
  const list = query.split('&') || [];
  const obj = {};
  list.forEach(item => {
    const [key,value] = item.split('=');
    obj[key] = value;
  })
  return obj[val] || '';
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App v-if="templateShow" />', // templateShow: 防止缓存中的accessKey与url中的accessKey不一致导致accessKey错乱
  data() {
    return {
      templateShow: false
    }
  },
  mounted() {
    const botKey = getPathData('botKey');
    const accessKey = getPathData('accessKey');
    const userId = getPathData('userId');
    if(botKey || accessKey){
      sessionStorage.setItem('accessKey', botKey || accessKey || '')
    }
    if(userId) {
      dataHandle.setCookie('X-User-Mobile',userId)
    };
    this.templateShow = true;
  },
})



// WEBPACK FOOTER //
// ./src/main.js